import React, { useEffect } from 'react'
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/trash-2.svg"

const PowerPurchasePreview = ({isOpen, setIsOpen, previewItems, setPreviewItems}) => {
    const removePreviewItem = (phoneNumber) => {
        const filtered = previewItems?.filter((item) => item?.phoneNumber !== phoneNumber);
        setPreviewItems(filtered);
    }

    useEffect(() => {
        if (previewItems?.length === 0 && isOpen === true) {
            setIsOpen(false);
        }
        // eslint-disable-next-line
    }, [previewItems])
    
    return (
        <div className='w-full overflow-y-scroll payment-preview'>
            <div className="flex items-center justify-between sticky top-0 right-0 bg-white">
                <div className="text-xl font-bold">
                    Payment Preview
                </div>
                
                <div onClick={() => {
                        setIsOpen(false);
                        setPreviewItems([]);
                    }} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                    <IconTimes width={30} />
                </div>
            </div>
            
            <div className="w-full pt-3">
                {previewItems?.map((item, index) => {
                    return (
                        <div className="mb-4 flex items-center justify-between" key={index}>
                            <div className="w-full mr-5 flex items-center rounded-xl p-3 border border-gray-300">
                                <div className='flex items-center justify-center h-8 w-8 rounded-full'>
                                    <img src={item?.network?.image} alt="biller-icon" />
                                </div>
                            
                                <div className='ml-4'>
                                    <p className="text-ep-gray-600 capitalize">{item?.name?.toLowerCase()}</p>
                                    
                                    <div className="flex items-center">
                                        <p className="text-ep-gray-500 uppercase text-sm">{item?.network?.label}</p>
                                        
                                        <span className='h-1 w-1 rounded-full bg-[#d1d5db] mx-2' />
                                        <p className="text-ep-gray-500">{item?.account}</p>
                                        
                                        <span className='h-1 w-1 rounded-full bg-[#d1d5db] mx-2' />
                                        <p className="text-ep-gray-500 capitalize">{item?.accountType}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <button onClick={() => removePreviewItem(item?.phoneNumber)}>
                                <IconTrash />
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default PowerPurchasePreview